var $jq = jQuery.noConflict();
var selectedProducts = [];
var delayTimer;
const settings = {
  variableWidth: true,
  arrows: true,
  infinite: false,
  mobileFirst: true,
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M8.70361 2.76978L17.7964 12.7719L8.70361 22.7739" stroke="#370003" stroke-width="2" stroke-linecap="square"/></svg></button>',
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M16.0435 2.47656L6.95685 12.4718L16.0435 22.4671" stroke="#370003" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 1400,
      settings: "unslick"
    }
  ],
}
const sl =  $jq('.caseBuilderBodyStatusBarProducts').slick(settings);
$jq(window).on('resize', function() {
  if( $jq(window).width() < 1400 &&  !sl.hasClass('slick-initialized')) {
    $jq('.caseBuilderBodyStatusBarProducts').slick(settings);
  }
});
$jq(window).on("scroll", function(){
  $jq(".firstCard").each(function(){
    if ($jq(this).isInViewportCase()) {
      let sectionTitle = $jq(this).attr("data-section-title");
      $jq(".caseBuilderBodyContentNavItem").removeClass("selected");
      $jq('.caseBuilderBodyContentNavItem:contains("'+sectionTitle+'")').addClass("selected");
    }
  });
});
$jq(".productCaseAdd").on("click", function(){
  let thisCard = $jq(this).closest("product-card");
  let product = {
    id: Number(thisCard.attr("data-product-id")),
    variant_id: Number(thisCard.attr("data-variant-id")),
    title: thisCard.attr("data-product-title"),
    image: thisCard.attr("data-product-image"),
    price: Number(thisCard.attr("data-variant-price")),
  };
  selectedProducts.push(product);
  updateSelectedProducts();
});
$jq(".productCaseRemoveLink").on("click", function(){
  let thisCard = $jq(this).closest("product-card");
  let product = {
    id: Number(thisCard.attr("data-product-id")),
  };
  selectedProducts.forEach((item, index) => {
    if(item.id == product.id) {
      selectedProducts.splice(index, 1);
    }
  });
  updateSelectedProducts();
});
$jq(".caseBuilderBodyResultProductRemove").on("click", function(){
  let thisCard = $jq(this).closest(".caseBuilderBodyResultProduct");
  let product = {
    id: Number(thisCard.attr("data-product-id")),
  };
  selectedProducts.forEach((item, index) => {
    if(item.id == product.id) {
      selectedProducts.splice(index, 1);
    }
  });
  updateSelectedProducts();
});
$jq(".caseBuilderBodyStatusBarProductRemove").on("click", function(){
  let thisCard = $jq(this).closest(".caseBuilderBodyStatusBarProduct");
  let product = {
    id: Number(thisCard.attr("data-product-id"))
  };
  selectedProducts.forEach((item, index) => {
    if(item.id == product.id) {
      selectedProducts.splice(index, 1);
    }
  });
  updateSelectedProducts();
});
if($jq(window).width() <= 989) {
  $jq(".caseBuilderBodyStatusBarProducts").hide();
}
$jq(".caseBuilderBodyStatusBarMobileToggle").on("click", function() {
  $jq(this).toggleClass("openProducts");
  $jq(".caseBuilderBodyStatusBarProducts").slideToggle();
});
$jq(".caseBuilderBodyContentNavMobileControlCollection").on("click", function(){
  $jq(this).toggleClass("navOpen");
  $jq(".caseBuilderBodyContentNavItems").slideToggle();
});
$jq(".caseBuilderBodyContentNavMobileControlSearch, .caseBuilderBodyContentNavSearchCloseButton").on("click", function(){
  $jq(".caseBuilderBodyContentNavSearch").slideToggle();
});
$jq(".caseBuilderBodyContentNavItem").on("click", function(){
  let thisSectionTitle = $jq(this).text();
  let firstCard = $jq("[data-section-title='"+thisSectionTitle+"']");
  if(firstCard) {
    if($jq(window).width() <= 1440) {
      $jq([document.documentElement, document.body]).animate({
        scrollTop: firstCard.first().offset().top - 305
      }, 1000);
    } else {
      $jq([document.documentElement, document.body]).animate({
        scrollTop: firstCard.first().offset().top - 240
      }, 1000);
    }
  }
});
$jq.fn.isInViewportCase = function() {
  var elementTop = $jq(this).offset().top;
  var elementBottom = elementTop + $jq(this).outerHeight();

  var viewportTop = $jq(window).scrollTop();
  var viewportBottom = viewportTop + $jq(window).height();
  if($jq(window).width() <= 1440) {
    return elementTop - 355 < viewportTop;
  } else {
    return elementTop - 280 < viewportTop;
  }
};
$jq(".caseItem").on("click", function(){
  if(!$jq(this).hasClass("selected")) {
    changeQty(this);
  }
});
$jq(".caseBuilderBodyResultButtonBelow").on("click", function(){
  changeQty(this);
});
$jq(".caseBuilderBodyStatusBarButton, .caseBuilderBodyResultButton").on("click", async function(){
  if(selectedProducts.length > 0) {
    await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    });
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    let formData = {
     'items': selectedProducts.map(item => {
       return {
         'id': item.variant_id,
         'quantity': 1
       }
     }),
      'sections': sectionsToBundle.join(",")
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(async function(responseJson) {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent1 = await fetch(`${Shopify.routes.root}cart.js`);
      const cartContent = await cartContent1.json();
      cartContent["sections"] = responseJson["sections"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          onSuccessDo: "force_open_drawer",
          cart: cartContent
        }
      }));
      selectedProducts = [];
      updateSelectedProducts();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
});
$jq(".caseBuilderBodyContentNavSearchInput").on("change paste keyup", doSearch);
function changeQty(elem) {
  let newQty = Number($jq(elem).attr("data-quantity"));
  $jq(".caseBuilderBodyWrapper").attr("[data-quantity='"+newQty+"']");
  selectedProducts = selectedProducts.slice(0,newQty);
  updateSelectedProducts();
  $jq(".caseItem").each(function(){
    let thisQty = Number($jq(this).attr("data-quantity"));
    if(thisQty == newQty) {
      $jq(this).addClass("selected");
    } else {
      $jq(this).removeClass("selected");
    }
  })
  $jq(".caseBuilderBodyResultButtonBelow").each(function(){
    let thisQty = Number($jq(this).attr("data-quantity"));
    if(thisQty > newQty) {
      $jq(this).removeClass("hideItem");
    } else {
      $jq(this).addClass("hideItem");
    }
  })
  $jq(".caseBuilderBodyStatusBarProduct1").each(function(index){
    hideElemByQty(newQty, index, this);
  });
  $jq(".caseBuilderBodyStatusBarProducts>svg").each(function(index){
    hideElemByQty(newQty-1, index, this);
  });
  $jq(".caseBuilderBodyResultProduct").each(function(index){
    hideElemByQty(newQty, index, this);
  });
  if(!sl.hasClass('slick-initialized')) {
    $jq('.caseBuilderBodyStatusBarProducts').slick(settings);
  }
  setTimeout(function() {
    $jq(".caseBuilderBodyStatusBarProduct1 svg").show();
    $jq(".caseBuilderBodyStatusBarProduct1:not(.hideItem)").last().find(">svg").hide();
  },50)
}
function doSearch() {
  clearTimeout(delayTimer);
  let that = this;
  delayTimer = setTimeout(function() {
    let searchString = $jq(that).val();
    let allProductTitles = [];
    let resultIndexes = [];
    $jq(".caseBuilderBodyContentProducts product-card").each(function() {
      allProductTitles.push($jq(this).find(".product-title").text());
    });
    for(let i=0; i<allProductTitles.length; i++) {
      let allProductTitle = allProductTitles[i];
      if(allProductTitle.toLowerCase().indexOf(searchString.toLowerCase()) > -1) {
        resultIndexes.push(i);
      }
    }
    if(resultIndexes.length > 0) {
      $jq(".caseBuilderBodyContentProducts product-card").each(function(index) {
        if(resultIndexes.indexOf(index) > -1) {
          $jq(this).removeClass("hideItem");
        } else {
          $jq(this).addClass("hideItem");
        }
      });
      $jq(".caseBuilderBodyContentProducts").removeClass("noResult");
    } else {
      $jq(".caseBuilderBodyContentProducts").addClass("noResult");
      $jq(".caseBuilderBodyContentProducts product-card").addClass("hideItem");
    }
  }, 700);
}
function hideElemByQty(newQty, index, elem){
  if(index >= newQty) {
    $jq(elem).addClass("hideItem");
  } else {
    $jq(elem).removeClass("hideItem");
  }
}
function updateSelectedProducts(){
  $jq(".caseBuilderBodyStatusBarProduct, .caseBuilderBodyContentProducts product-card, .caseBuilderBodyResultProduct").removeClass("selected");
  $jq(".caseBuilderBodyResultProductTitle").html("");
  $jq(".caseBuilderBodyStatusBarProduct").removeAttr("data-product-id");
  $jq(".caseBuilderBodyStatusBarProduct").each(function(index) {
    if(typeof selectedProducts[index] != "undefined") {
      let product = selectedProducts[index];
      $jq(this).addClass("selected");
      $jq(this).attr("data-product-id", product.id);
      $jq(this).find(".caseBuilderBodyStatusBarProductImageTag").attr("src", product.image);
    }
  });
  $jq(".caseBuilderBodyResultProduct").each(function(index) {
    if(typeof selectedProducts[index] != "undefined") {
      let product = selectedProducts[index];
      $jq(this).addClass("selected");
      $jq(this).attr("data-product-id", product.id);
      $jq(this).find(".caseBuilderBodyResultProductImage").attr("src", product.image);
      $jq(this).find(".caseBuilderBodyResultProductTitle").html(product.title);
    }
  });
  $jq(".caseBuilderBodyContentProducts product-card").each(function(){
    let productId = Number($jq(this).attr("data-product-id"));
    let addThis = false;
    selectedProducts.forEach((item, index) => {
      if(item.id == productId) {
        addThis = true;
      }
    });
    if(addThis) {
      $jq(this).addClass("selected");
    }
  });
  let totalPrice = 0;
  selectedProducts.forEach((item, index) => {
    totalPrice += item.price;
  });
  $jq(".casePrice").html(formatMoneyCase(totalPrice, moneyFormarCase));
}
function formatMoneyCase(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};